<template>
  <div class="small-graph small-graph--light">
    <div class="small-graph-header">
      <div class="small-graph-name">{{ label }}</div>
      <div class="small-graph-count" v-if="percent !== undefined">
        {{ formattedPercent }}%
      </div>
    </div>
    <div class="small-graph-bar-wrap">
      <div class="small-graph-bar"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RoeSurveyBarLight",
  props: {
    label: {
      type: String,
      required: true
    },
    percent: {
      type: Number,
      required: false
    }
  },
  computed: {
    formattedPercent() {
      return (this.percent * 100).toFixed(0);
    }
  }
};
</script>
